import React from 'react'
import { Prize, PrizeContainer } from '../PrizeComponents'
import TiptapEditor from '../TiptapEditor'
import usePrizeSlideshow from '../../hooks/usePrizeSlideshow'
import Style from './style'
import useColorCookie from 'shared/model/useColorCookie'

const PrizeSlideshow = ({ 
	prizeArray = [],
	prizeList = [],
	duration = 5000, 
	showIndicators = false,
	showNavigation = false,
	className,
	...props 
}) => {
	const [colorCookie] = useColorCookie()
	const fontColor = colorCookie?.basic.font

	const {
		currentIndex,
		isVisible,
		currentPrize,
		goToNext,
		goToPrev,
		goToIndex,
		hasMultiple
	} = usePrizeSlideshow(prizeArray, duration)

	if ((!prizeArray || prizeArray.length === 0) && (!prizeList || prizeList.length === 0)) {
		return (
			<div className={className}>
				<p>프라이즈 데이터가 없습니다.</p>
			</div>
		)
	}

	return (
		<Style.SlideshowContainer className={className} {...props}>
			{prizeArray.length > 0 ? <>
						{/* Prize Display */}
						<Style.SlideContainer $isVisible={isVisible}>
				<PrizeContainer>
					<Prize
						key={`prize-${currentIndex}`}
						index={currentIndex}
						simplified={true}
						showRemoveButton={false}
					>
						<TiptapEditor
							key={`prize-${currentIndex}`}
							initialContent={currentPrize || ''}
							placeholder={`프라이즈 ${currentIndex + 1} 정보를 입력하세요...`}
							editable={false}
						/>
					</Prize>
				</PrizeContainer>
			</Style.SlideContainer>

			{/* Navigation Arrows (optional) */}
			{showNavigation && hasMultiple && (
				<>
					<Style.NavButton $position="left" onClick={goToPrev}>
						‹
					</Style.NavButton>
					<Style.NavButton $position="right" onClick={goToNext}>
						›
					</Style.NavButton>
				</>
			)}

			{/* Indicators (optional) */}
			{showIndicators && hasMultiple && (
				<Style.IndicatorContainer>
					{prizeArray.map((_, index) => (
						<Style.Indicator
							key={index}
							$active={index === currentIndex}
							$fontColor={fontColor}
							onClick={() => goToIndex(index)}
						/>
					))}
				</Style.IndicatorContainer>
			)}

			</> : <>
			{ prizeList.length === 0 ? <>
			</> : <>
			<Style.PrizeList $itemCount={prizeList?.length || 0}>
            {prizeList?.map((elem, index) =>
                                    <div key={index}>
                                        <p>{elem[0]}</p>
                                        <p>{elem[1]}</p>
                                    </div>
                                )}
                            </Style.PrizeList>
			</> }
			</> }

	
		</Style.SlideshowContainer>
	)
}

export default PrizeSlideshow
